import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import theme from "./theme";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Routing from "./components/Routing";
import Container from "./components/Container";
import { COMPACT_QUERY } from "./utils/hooks/useCompact";
import { canAccessGDP } from "./permissions/access";

function App() {
  // Roles without GDP access (e.g. the Sale role) only ever see the Permission
  // Denied page, so hide the feature sidebar for them — the Header still offers
  // branding and logout.
  const allowed = canAccessGDP();

  const content = (
    <Container>
      <Box
        sx={{
          padding: "16px 0",
          [`@media ${COMPACT_QUERY}`]: { padding: "8px 0" },
        }}
      >
        <Routing />
      </Box>
    </Container>
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            bgcolor: "background.default",
          }}
        >
          <Header />
          {allowed ? (
            <Box sx={{ display: "flex", flex: 1, minHeight: 0 }}>
              <Sidebar />
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>{content}</Box>
            </Box>
          ) : (
            content
          )}
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
